module.exports = __webpack_public_path__ + "images/store_case_study/brandvalue-pic1_e47173176ad56fae78dfac1935c94b07.png";